import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const gammes = [
  {
    titleKey: 'gamme_1_title',
    subKey: 'gamme_1_sub',
    dureeKey: 'gamme_1_duree',
    garantieKey: 'gamme_1_garantie',
    descKey: 'gamme_1_desc',
    img: 'https://readdy.ai/api/search-image?query=Close-up of standard 3-tab asphalt shingle roof texture, grey slate color, rectangular uniform pattern, professional roofing detail shot, warm afternoon light, Quebec residential construction, clean sharp macro photography, no text visible, editorial quality, landscape composition',
    alt: 'Bardeau standard 3 pattes gris ardoise texture macro',
  },
  {
    titleKey: 'gamme_2_title',
    subKey: 'gamme_2_sub',
    dureeKey: 'gamme_2_duree',
    garantieKey: 'gamme_2_garantie',
    descKey: 'gamme_2_desc',
    img: 'https://readdy.ai/api/search-image?query=Close-up of architectural dimensional asphalt shingle roof with 3D texture, dark grey color, layered overlapping pattern, professional roofing detail macro shot, warm golden light, Quebec residential construction, premium quality, no text visible, editorial quality',
    alt: 'Bardeau architectural 3D texture épaisseur premium',
  },
  {
    titleKey: 'gamme_3_title',
    subKey: 'gamme_3_sub',
    dureeKey: 'gamme_3_duree',
    garantieKey: 'gamme_3_garantie',
    descKey: 'gamme_3_desc',
    img: 'https://readdy.ai/api/search-image?query=Close-up of premium designer asphalt shingle roof with slate-like texture, double thickness, dark charcoal color, luxury residential roofing detail, professional macro photography, dramatic warm lighting, Quebec premium construction, no text visible',
    alt: 'Bardeau premium designer look ardoise double épaisseur',
  },
];

export default function GammesBardeau() {
  const { t } = useTranslation('bardeau');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="gammes" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('gammes_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-6">
          {gammes.map((gamme, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-xl overflow-hidden transition-all duration-700 hover:-translate-y-1 hover:shadow-sm ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150 + 200}ms` }}
            >
              <div className="h-48 md:h-52 overflow-hidden">
                <img
                  src={gamme.img}
                  alt={`${gamme.alt} — couvreur RBQ à Lévis`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="600"
                  height="400"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block text-copper text-xs font-semibold uppercase tracking-wider bg-copper/10 px-2 py-1 rounded-full mb-2">
                  {t(gamme.subKey)}
                </span>
                <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-2">
                  {t(gamme.titleKey)}
                </h3>
                <div className="flex flex-wrap gap-2 mb-3">
                  <span className="text-xs bg-soft-gray px-2 py-1 rounded-full text-slate-primary/70">
                    {t(gamme.dureeKey)}
                  </span>
                  <span className="text-xs bg-soft-gray px-2 py-1 rounded-full text-slate-primary/70">
                    {t(gamme.garantieKey)}
                  </span>
                </div>
                <p className="text-slate-primary/60 text-xs md:text-sm leading-relaxed">
                  {t(gamme.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}